import styled from 'styled-components';

const handleStatus = bgColor => {
  switch (bgColor) {
    case 'provide':
      return '#eb2026';
    case 'pending':
      return '#e1e40d';
    case 'verified':
      return '#249995';
    default:
      return 'transparent';
  }
};

const handleColor = color => {
  switch (color) {
    case 'provide':
      return '#fff';
    case 'pending':
      return '#000';
    case 'verified':
      return '#fff';
    default:
      return 'transparent';
  }
};

export const HeaderOuterWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    direction: ltr;
    background-color: ${props.theme.colors.white.base};
    padding: ${
      props.headCheck ? 0 : `${props.theme.spacing.base} 0 ${props.theme.spacing.small.s5}`
    } ;
    @media only screen and (min-width:320px) and (max-width: 1023px){
      display: none;
    }
  `,
);

export const HeaderInnerWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    max-width:1200px;
    margin: 0 auto;
  `,
);

export const LogoVerticalOuterWrap = styled.div(
  props => `
    width:40%;
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
);

export const LogoWrapper = styled.div(
  props => `
    width:${props.headCheck ? '30%' : '40%'};
    display: flex;

    cursor: pointer;

    .whiteLabelLogoInitialText {
      background-color: #ec1c24;
      border-radius: 5px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: 900;
      width: 37px;
      height: 37px;
    }

    .logoImgHeight {
      max-height: 50px;
    }

    .logoImg {
      height: 37px;
      width: 37px;
    }

    .whiteLabelLogo {
      width: 37px;
      height: 37px;
      //background-color: #ec1c24;
      border-radius: 5px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: 900;
    }

    .whiteLabelLogoImg {
      height: 37px;
      width: 37px;
      border-radius: 5px;
      background-color: transparent; 
    }

    .whiteLabelLogoText {
      width: 137px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
       text-transform: uppercase;
    }

    .font12 {
      font-size: 12px;
    }

    .font16 {
      font-size: 16px;
    }

    .component-with-coach-mark-wrapper.userDropDown-coachMark-wrapper {
      .coach-mark-type1-wrapper {
        left: -757px;
        top: 408px;
        right: unset;
      }
      .coach-mark-type1-wrapper .arrowIcon {
        width: 75px;
        transform: scaleY(-1);
      }
      .component-with-coach-mark-children-wrapper {
        height: unset;
        & > * {
          width:350px
        }
      }
    }

    .component-with-coach-mark-wrapper.userProfile-coachMark-wrapper {
      .coach-mark-type1-wrapper {
        top: 42px;
        right: 14px;
      }
      .coach-mark-type1-wrapper .arrowIcon {
        width: 75px;
        transform: scaleY(-1);
      }
    }


    .component-with-coach-mark-wrapper {
      width: 100%;
      font-size: 1rem;
      color: #000000;
      font-weight: bold;
      display: flex;
      gap: 5px;
      align-items: center;

      .coach-mark-type1-wrapper {
        flex-direction: row-reverse;
        top: 50px;
        left: 0px;

        .arrowIcon {
          transform: rotate(180deg);
          margin-left: 16px;
        }
      }

      .headerLogo {
        width: 150px;
      }

      .whiteLabelLogo {
        width: 37px;
      }

      .component-with-coach-mark-children-wrapper {
        background: unset;

        .whiteLabelLogo {
          width: 37px;
        }

        .headerLogo {
          width: 150px;
        }

        .whiteLabelLogoText {
          width: 137px;
        }
      }
    }
  `,
);

export const VerticalIconWrap = styled.div(
  props => `
    width: 80%;
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
);

export const VerticalIconList = styled.ul(
  props => `
    list-style-type: none;
    display: flex;

    li{
      padding: 0 ${props.theme.spacing.base} ${props.theme.spacing.small.s2};
      display: flex;
      flex-direction: column;
      border-bottom: 3px solid transparent;
      max-width: 80px;
      margin: 0 ${props.theme.spacing.base};
      cursor: pointer;
      align-items: center;
      position: relative;
      .svgImageFit > image{
        width: 100% !important;
        height: 100% !important;
        object-fit: contain !important;
      }

      p{
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.base};
        padding-bottom: ${props.theme.spacing.small.s5};
        font-weight: ${props.theme.font.fontWeight.bold};
        padding: ${props.theme.spacing.small.s2} ${props.theme.spacing.small.s5};
      }

      &.active{
        p{
          font-size: ${props.theme.font.base};
          color: ${props.theme.colors.white.base};
          padding-bottom: ${props.theme.spacing.small.s5};
          font-weight: ${props.theme.font.fontWeight.bold};
          background-color: ${props.theme.colors.blue.base};
          padding: ${props.theme.spacing.small.s2} ${props.theme.spacing.small.s5};
          border-radius: 1rem;
        }
        &::after{
          display: flex;
          content: '';
          position: absolute;
          bottom:-2.3rem;
          left:2.3rem;
          z-index:2;
          border-top: 10px solid #fff;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-bottom: 10px solid transparent;
        }
      }

      &:hover{
        p{
          font-size: ${props.theme.font.base};
          color: ${props.theme.colors.white.base};
          padding-bottom: ${props.theme.spacing.small.s5};
          font-weight: ${props.theme.font.fontWeight.bold};
          background-color: ${props.theme.colors.blue.base};
          padding: ${props.theme.spacing.small.s2} ${props.theme.spacing.small.s5};
          border-radius: 1rem;
        }
      }
    }
  `,
);

export const UserInfoWrap = styled.div(
  props => `
    width: ${props.headCheck ? '60%' : '60%'};
    display: flex;
    justify-content: flex-end;
    align-items: center;
    @media only screen and (min-width:320px) and (max-width: 767px){
        text-aling: right;
        flex-direction: column;
        align-items: flex-end;
    }

    @media only screen and (min-width:768px) and (max-width: 1024px){
        text-aling: right;
        flex-direction: column;
        align-items: flex-end;
    }
  `,
);

export const UserOptionWrap = styled.div(
  props => `
    display: flex;
    background-color: ${props.theme.colors.white.light15};
    padding: ${props.theme.spacing.small.s7} ${props.theme.spacing.base};
    border-radius: ${props.theme.misc.borderRadius.base};
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
    cursor: pointer;
    height: 4rem;
    align-items: center;
  `,
);

export const UserOptionWrapNew = styled.div(
  props => `
    display: flex;
    padding: ${props.theme.spacing.small.s7} ${props.theme.spacing.base};
    cursor: pointer;
    height: 4rem;
    align-items: center;
    border-right: 2px dotted #e3c9e8;
  `,
);

export const NameTextWrap = styled.div(
  props => `
    max-width:90%;
    display: inline-flex;
  `,
);

export const UserOptionIconWrap = styled.div(
  props => `
    display: flex;
  `,
);

export const UserOptionTextWrap = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    padding-left: ${props.theme.spacing.small.s7};
  `,
);

export const UserOptionHeadText = styled.p(
  props => `
    font-size: ${props.theme.font.small.font10};
    color: ${props.theme.colors.white.base};
    font-weight: ${props.theme.font.fontWeight.bold};
  `,
);

export const UserNameHeadTextNew = styled.p(
  props => `
    font-size: ${props.theme.font.small.font10};
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.bold};
  `,
);

export const UserOptionHeadTextNew = styled.p(
  props => `
    font-size: ${props.theme.font.small.font10};
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.bold};
  `,
);

export const UserOptionSubText = styled.p(
  props => `
    font-size: ${props.theme.font.small.font10};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
  `,
);

export const AedText = styled.span(
  props => `
    font-size: ${props.theme.font.small.font10};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
  `,
);

export const UserOptionProfileWrap = styled.div(
  props => `
    width: 15.5rem;
    height:4rem;
    display: flex;
    margin-left: ${props.theme.spacing.small.s5};
    background-color: ${props.headCheck ? 'none' : `${props.theme.colors.white.light15}`};
    padding: ${props.theme.spacing.small.s7} ${props.theme.spacing.base};
    // border-radius: ${props.headCheck ? 'none' : `${props.theme.misc.borderRadius.base}`};
    // box-shadow: ${props.headCheck ? 'none' : '0 1px 4px 0 rgba(0, 0, 0, 0.2)'};
    cursor: default;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    cursor: pointer;

    &:hover{
      ${UserMoreInfoWrap} {
        display: flex !important;
      }
    }
  `,
);

export const UserProfileIconWrap = styled.div(
  props => `
    width:2.2rem;
    height: 2.2rem;
    position: relative;
    img{
      width:2.2rem;
      height: 2.2rem;
      border-radius: 50%;
    }
  `,
);

export const UserProfileTextWrap = styled.div(
  props => `
    width: 8.5rem;
    dispaly: flex;
    flex-direction: column;
    margin: 0 ${props.theme.spacing.small.s5};
  `,
);

export const UserProfileHeadText = styled.p(
  props => `
    font-size: ${props.theme.font.small.font10};
    color: ${props.theme.colors.white.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width:95%;
  `,
);

export const UserProfileSubText = styled.p(
  props => `
    font-size: ${props.theme.font.small.font10};
    color: ${props.theme.colors.grey.light9b};
    font-weight: ${props.theme.font.fontWeight.bold};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width:95%;
  `,
);

export const UserProfileMoreInfoWrap = styled.div(
  props => `
  display: flex;
  align-self: flex-end;
  margin: auto;
`,
);

export const UserMoreInfoWrap = styled.div(
  props => `
    width: 35rem;
    flex-direction: column;
    display: none;
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.base};
    box-shadow: 0 3px 5px 0 rgba(152, 152, 152, 0.5);
    position: absolute;
    top: 4.1rem;
    right: 0;
    z-index: 10;
  `,
);

export const UserMoreInfoOuterWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    padding: ${props.theme.spacing.large.l15};
    border-bottom: 1px solid ${props.theme.colors.grey.lighte7};
    align-items: center;
    cursor: default;
  `,
);

export const UserProfileImgWrap = styled.div(
  props => `
    width: 5rem;
    height: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 1rem;
    position: relative;
    img {
      width: 5rem;
      height: 5rem;
    }
  `,
);

export const UserProfileInfoWrap = styled.div(
  props => `
    display: flex;
    width: 90%;
    flex-direction: column;
  `,
);

export const UserProfileNameText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font16};
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.black};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width:95%;
  `,
);

export const UserProfileEmailText = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.black.base};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width:95%;
  `,
);

export const UserMoreInfoInnerWrap = styled.ul(
  props => `
    width:100%;
    display: flex;
    padding: ${props.theme.spacing.large.l15};
    flex-direction: column;
    list-style-type: none;
    cursor: default;
    li{
        width:100%;
        display: flex;
        aling-items: flex-start;
        justify-content: dlex-start;
        padding-bottom: ${props.theme.spacing.large.l20};
        cursor: pointer;

        &:last-of-type{
            padding-bottom: 0;
        }

    }
  `,
);

export const MenuIconWrap = styled.div(
  props => `
    width:4rem;
    height: 3rem;
    margin-right: ${props.theme.spacing.large.l13};
    aling-items: center;
    justify-content: center;
    margin-top: ${props.theme.spacing.small.s2};
  `,
);

export const MenuInfoWrap = styled.div(
  props => `
    width:90%;
    display: flex;
    flex-direction: column;
  `,
);

export const MenuHeading = styled.p(
  props => `
    font-size: ${props.theme.font.large.font16};
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.black};
  `,
);

export const MenuSubHeading = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    line-height: 1.2;
    padding-top: ${props.theme.spacing.small.s5};
  `,
);

export const ImageCirle = styled.div(
  props => `
    width: 2.2rem;
    height: 2.2rem;
    object-fit: contain;
    background-color: ${props.theme.colors.blue.base};
    border-radius: 50%;
    color: ${props.theme.colors.white.base};
    text-align: center;
    text-transform: uppercase;
    font-weight: 900;
    padding: 0.5rem;
    font-size: 1rem;
  `,
);
export const ImageCirleBig = styled(ImageCirle)(
  props => `
    width: 3.7rem;
    height: 3.7rem;
    font-size: 2rem;
    margin: auto;
  `,
);

export const NotifiyCircle = styled.div`
  width: 0.8rem;
  border-radius: 5px;
  height: 0.8rem;
  background-color: ${({bgColor}) => handleStatus(bgColor)};
  position: absolute;
  top: -2px;
  right: 0;
`;

export const NotifiyCircleBig = styled.div`
  width: 1.6rem;
  border-radius: 1rem;
  height: 1.6rem;
  background-color: ${({bgColor}) => handleStatus(bgColor)};
  position: absolute;
  top: 0.3rem;
  right: 1rem;
`;

export const ProfileHeadWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
);

export const ProfileStatus = styled.p`
  padding: 2px 4px;
  background-color: ${({bgColor}) => handleStatus(bgColor)};
  color: ${({color}) => handleColor(color)};
  font-size: 1.2rem;
  text-align: right;
  border-radius: 0.4rem;
`;
export const BkngSlctBackOverlay = styled.div(
  props => `
      width:100%;
      background-color: rgba(0,0,0,0.4);
      position: fixed;
      top:0;
      left:0;
      right:0;
      bottom: 0;
      z-index: 11;
    `,
);

export const BkngSelectOverlay = styled.div(
  props => `
      width:38rem;
      height:auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content:center;
      position: absolute;
      top:5.5rem;
      right: 15%;
      transform: translateX(-50%);
      background-color: ${props.theme.colors.white.base};
      z-index:99;
      border-radius: .4rem;
      box-shadow: 0px 0px 3px 3px rgb(0 0 0 / 20%);
    `,
);

export const BkngSelectWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      padding: ${props.theme.spacing.large.l20};
      border-bottom:1px solid ${props.theme.colors.grey.lighte7};
      flex-direction: column;
      align-items: center;
      justify-content: center;
    `,
);

export const BkngSelectText = styled.p(
  props => `
      font-size: ${props.theme.font.large.font16};
      color: ${props.theme.colors.grey.base};
      font-weight: ${props.theme.font.fontWeight.bold};
    `,
);

export const BkngSelectBtn = styled.button(
  props => `
      display: flex;
      padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15};
      background-color: ${props.theme.colors.blue.base};
      color: ${props.theme.colors.white.base};
      font-size: ${props.theme.font.large.font16};
      font-weight: ${props.theme.font.fontWeight.bold};
      outline: none;
      margin-top: ${props.theme.spacing.base};
      align-items: center;
      justify-content: center;
      border: none;
      border-radius: 0.4rem;
      cursor: pointer;
    `,
);

export const NavPopList = styled.div(
  props => `
    display: flex;
    padding-left: 2px;
    width: 54px;
    padding-top: 5px;
    `,
);
